import { newrelic } from "@jti/fe-clients";
import { getConfig } from "@jti/fe-common";
import type { AvpContract } from "@jti/rest-api-types";

import { createLegacyApiWarningAttributes, getIsEvo } from "../../utils";

import { AvpApiEvo } from "./AvpApiEvo";
import { AvpAPILegacy } from "./AvpApiLegacy";

/**
 * AVP - Age Verification Proxy
 */
export class AvpAPI {
  static init(): AvpContract {
    const config = getConfig();

    if (config.USE_EVO_ONLY) {
      return new AvpApiEvo(config.EVO_DOMAIN, config.EVO_TENANT, config["X-RECAPTCHA-ID"], config.ISO_COUNTRY_CODE);
    }

    if (getIsEvo(config.AVP_URL)) {
      return new AvpApiEvo(
        config.AVP_URL,
        config.AVP_X_DES_AK_TENANT_TOKEN,
        config["X-RECAPTCHA-ID"],
        config.ISO_COUNTRY_CODE
      );
    }

    newrelic.sendWarning(
      "AvpAPILegacy initialized - legacy API client in use",
      createLegacyApiWarningAttributes(config, config.AVP_URL)
    );

    return new AvpAPILegacy(config.AVP_URL, config.AVP_X_DES_AK_TENANT_TOKEN, config.ISO_COUNTRY_CODE);
  }
}
